import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

/** Lightweight wishlist hook backed by /me/wishlist (only when logged in) */
export function useWishlist() {
    const { user } = useAuth();
    const [ids, setIds] = useState(new Set());
    const [loading, setLoading] = useState(false);

    const refresh = useCallback(async () => {
        if (!user || user.role !== "customer") {
            setIds(new Set());
            return;
        }
        setLoading(true);
        try {
            const { data } = await api.get("/me/wishlist");
            setIds(new Set(data.map((p) => p.id)));
        } catch {}
        setLoading(false);
    }, [user]);

    useEffect(() => { refresh(); }, [refresh]);

    const toggle = async (productId) => {
        if (!user || user.role !== "customer") return false;
        if (ids.has(productId)) {
            await api.delete(`/me/wishlist/${productId}`);
            setIds((prev) => {
                const next = new Set(prev);
                next.delete(productId);
                return next;
            });
            return false;
        }
        await api.post("/me/wishlist", { product_id: productId });
        setIds((prev) => new Set(prev).add(productId));
        return true;
    };

    return { ids, has: (id) => ids.has(id), toggle, refresh, loading };
}
